(() => {
  const dialog = document.querySelector('[data-sw-popup]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'tbtt-switch-witch-popup-v1';
  const pendingKey = 'tbtt-lead-conversion-pending';
  const delay = 5 * 1000;
  const cooldown = 24 * 60 * 60 * 1000;
  let memory = {};
  const read = () => { try { return JSON.parse(localStorage.getItem(key)) || {}; } catch (_) { return memory; } };
  const save = (value) => { memory = value; try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* Storage is optional. */ } };
  let timer;
  let previousFocus;
  const form = dialog.querySelector('.sw-form');
  if (form) form.addEventListener('submit', () => {
    if (!form.checkValidity()) return;
    try { sessionStorage.setItem(pendingKey, 'homepage_popup'); } catch (_) { /* Storage is optional. */ }
  });
  const pause = () => save({...read(), nextShow: Date.now() + cooldown});
  const open = () => {
    if (dialog.open) return;
    clearTimeout(timer);
    previousFocus = document.activeElement;
    dialog.showModal();
    document.body.classList.add('sw-popup-is-open');
    pause();
    // Avoid opening the phone keyboard automatically; focus a result when returned by Shopify.
    (dialog.querySelector('[data-sw-popup-result]') || dialog.querySelector('.sw-popup-close')).focus();
  };
  dialog.querySelector('.sw-popup-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.classList.remove('sw-popup-is-open');
    pause();
    if (previousFocus instanceof HTMLElement && previousFocus !== document.body && previousFocus.isConnected) previousFocus.focus();
    else {
      const main = document.querySelector('#MainContent');
      if (main) { main.setAttribute('tabindex', '-1'); main.focus({preventScroll:true}); }
    }
  });
  const result = dialog.querySelector('[data-sw-popup-result]');
  if (result?.classList.contains('sw-success')) {
    dialog.classList.add('sw-popup--success');
    const heading = result.querySelector('[data-sw-success-heading]');
    if (heading?.id) dialog.setAttribute('aria-labelledby', heading.id);
    dialog.querySelector('.sw-popup-close').setAttribute('aria-label', 'Close confirmation');
  }
  if (result?.classList.contains('sw-success')) save({subscribed: true});
  if (result) open();
  else {
    const state = read();
    if (!state.subscribed && !(state.nextShow > Date.now())) timer = setTimeout(open, delay);
  }
})();
